import React from 'react'
import { NavigationProvider } from '../components/navigation/NavigationProvider'
import { EnhancedNavigationSidebar } from '../components/navigation/EnhancedNavigationSidebar'

export function NavDemo() {
  const enabled = (import.meta as any).env?.VITE_NAV_PROGRESSIVE_ENABLED
  return (
    <div className="min-h-screen bg-gray-50 flex">
      <NavigationProvider>
        <EnhancedNavigationSidebar />
        <main className="flex-1 p-6">
          <div className="max-w-4xl">
            <h1 className="text-2xl font-semibold text-gray-900 mb-2">Navigation Preview</h1>
            {!enabled && (
              <p className="text-sm text-gray-500 mb-4">Note: Progressive navigation demo route is active. Set VITE_NAV_PROGRESSIVE_ENABLED=true to enable globally later.</p>
            )}
            <div className="bg-white rounded-lg border border-gray-200 p-6">
              <p className="text-gray-600">Use the sidebar on the left to interact with groups and items. This page is for UI preview only.</p>
            </div>
          </div>
        </main>
      </NavigationProvider>
    </div>
  )
}

